import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import LeadManagement from '../components/LeadManagement.js';
import FloatingDialPad from '../components/FloatingDialPad.js';
import WhatsAppCallButton from '../components/WhatsAppCallButton.js';
import TopBar from '../components/TopBar.js';
import { Toaster } from 'react-hot-toast';

const MyLeads = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  const session = React.useMemo(() => {
    try {
      const raw = sessionStorage.getItem('rbac_session');
      const parsed = raw ? JSON.parse(raw) : null;
      return parsed;
    } catch (e) { return null; }
  }, []);

  const [rbacRole, setRbacRole] = React.useState(null);
  React.useEffect(() => {
    if (!session?.token) return;
    try {
      const payload = JSON.parse(atob(session.token.split('.')[1]));
      setRbacRole({
        id: payload.role_id,
        username: payload.username,
        role_name: payload.role_name
      });
    } catch (e) {
      console.error('JWT decode failed:', e);
    }
  }, [session]);

  const logout = () => {
    sessionStorage.removeItem('rbac_session');
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f3ff', fontFamily: 'Inter, sans-serif' }}>
      <Toaster position="top-right" />
      <FloatingDialPad />
      <WhatsAppCallButton />
      <TopBar clientId={clientId} />
      <div style={{ padding: '20px' }}>
        {!rbacRole && (
          <div style={{ textAlign: 'center', padding: '40px', color: '#7C3AED', fontSize: '14px' }}>
            Loading agent profile...
          </div>
        )}
        {rbacRole && (
          <LeadManagement
            user={{
              id: rbacRole?.id,
              client_id: session?.client_id,
              rbac_role_id: rbacRole?.id
            }}
            assignedOnly={true}
            rbacRoleId={rbacRole?.id}
          />
        )}
      </div>
    </div>
  );
};

export default MyLeads;
